<h2 translate>dashboard.active.parameters</h2>
<mat-dialog-content>
	<form [formGroup]="formGroup">
		<table id="parameters" *ngIf="serviceParams">
			<tr>
				<th translate>organization.card.administrator.name</th>
				<th translate>organization.card.services.tab.desc</th>
				<th translate>service.parameters.value</th>
			</tr>
			<tr *ngFor="let parameter of serviceParams">
				<td>{{parameter?.serviceParameter?.name}}</td>
				<td>{{parameter?.serviceParameter?.description}}</td>
				<td class="parameter-dropdown">
					<mat-select [formControlName]="parameter?.serviceParameter?.id ?? null">
						<mat-option *ngFor="let value of parameter?.serviceParameter?.availableValues ?? []"
							[value]="value">
							{{ value }}
						</mat-option>
					</mat-select>
				</td>
			</tr>
		</table>
	</form>
</mat-dialog-content>
<mat-dialog-actions class="action-button">
	<button type="submit" mat-button [mat-dialog-close]="this.formGroup.value" class="dialog-button">
		<span translate>datacenter.save</span>
	</button>
	<button type="submit" mat-button [mat-dialog-close]="false" class="dialog-button">
		<span translate>dashboard.cancel</span>
	</button>
</mat-dialog-actions>
